import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2, AlertTriangle } from "lucide-react";
import { useAuth, formatApiErrorDetail } from "@/lib/auth";
import PageHeader from "@/components/PageHeader";

export default function AuthVerify() {
    const { verifyToken } = useAuth();
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState("verifying"); // verifying | ok | error
    const [errorMsg, setErrorMsg] = useState("");

    useEffect(() => {
        const token = params.get("token");
        if (!token) {
            setStatus("error");
            setErrorMsg("Missing token.");
            return;
        }
        (async () => {
            try {
                const user = await verifyToken(token);
                setStatus("ok");
                setTimeout(() => {
                    navigate(["master_admin", "admin"].includes(user?.role) ? "/admin" : "/jarvis", {
                        replace: true,
                    });
                }, 900);
            } catch (err) {
                setErrorMsg(
                    formatApiErrorDetail(err?.response?.data?.detail) ||
                        "We couldn't verify that link.",
                );
                setStatus("error");
            }
        })();
         
    }, []);

    return (
        <div data-testid="auth-verify-page">
            <PageHeader
                eyebrow="Sign in"
                title="Finishing up…"
                subtitle="One second while we complete your secure sign-in."
            />
            <section className="mm-section bg-white">
                <div className="mm-container max-w-md">
                    <div className="mm-card p-8 text-center" data-testid="auth-verify-card">
                        {status === "verifying" && (
                            <>
                                <Loader2
                                    className="mx-auto animate-spin text-mm-navy"
                                    size={28}
                                />
                                <p className="mt-4 text-mm-muted">Verifying your link…</p>
                            </>
                        )}
                        {status === "ok" && (
                            <>
                                <CheckCircle2
                                    className="mx-auto text-emerald-600"
                                    size={28}
                                />
                                <p className="mt-4 text-mm-ink">You're signed in. Redirecting…</p>
                            </>
                        )}
                        {status === "error" && (
                            <>
                                <AlertTriangle
                                    className="mx-auto text-amber-600"
                                    size={28}
                                />
                                <p className="mt-4 text-mm-ink">{errorMsg}</p>
                                <button
                                    onClick={() => navigate("/jarvis")}
                                    className="mm-btn-outline mt-6"
                                    data-testid="auth-verify-back"
                                >
                                    Back to Jarvis
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </section>
        </div>
    );
}
